












import { Component, Vue, Watch } from 'vue-property-decorator';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
@Component({
  components: {
    VuePdfEmbed,
  },
})
export default class Index extends Vue {
  private uuid: string = this.$route.params.uuid;
  private pdfLatest = null;

  mounted() {
    this.axios
      .get(`/tac/${this.uuid}`)
      .then((result: any) => {
        if (result.status === 200) {
          this.pdfLatest = result.data.data;
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}
